module.exports = __webpack_public_path__ + "images/blue-compare-arrows-0679c645.svg";